// Generated by CoffeeScript 1.12.7
module.exports = function(paths) {
  return paths.forEach(function(p) {
    return delete require.cache[p];
  });
};
